"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolTipBox = exports.ToolTipArrow = exports.StyledCloseButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2;

var ToolTipArrow = _styledComponents["default"].div.withConfig({
  displayName: "Tooltipstyles__ToolTipArrow",
  componentId: "sc-6fjxuf-0"
})(["position:absolute;width:12px;height:12px;background:inherit;visibility:hidden;&[data-popper-placement^='top']{bottom:-6px;}&[data-popper-placement^='bottom']{top:-6px;}&[data-popper-placement^='left']{right:-6px;}&[data-popper-placement^='right']{left:-6px;}&::before{position:absolute;width:12px;height:12px;background:inherit;visibility:visible;content:'';transform:rotate(45deg);", "}"], function (_ref) {
  var placement = _ref.placement;
  if (placement.startsWith('top')) return 'box-shadow: 3px 3px 8px -4px rgba(0, 0, 0, 0.4);';
  if (placement.startsWith('bottom')) return 'box-shadow: -3px -3px 8px -4px rgba(0, 0, 0, 0.4);';
  if (placement.startsWith('left')) return 'box-shadow: 3px -3px 8px -4px rgba(0, 0, 0, 0.4);';
  if (placement.startsWith('right')) return 'box-shadow: -3px 3px 8px -4px rgba(0, 0, 0, 0.4);';
  return '';
});

exports.ToolTipArrow = ToolTipArrow;

var ToolTipBox = _styledComponents["default"].div.withConfig({
  displayName: "Tooltipstyles__ToolTipBox",
  componentId: "sc-6fjxuf-1"
})(["", " background-color:#fff !important;box-shadow:0px 4px 16px rgba(0,0,0,0.4);"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["pa2"]))));

exports.ToolTipBox = ToolTipBox;

var StyledCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "Tooltipstyles__StyledCloseButton",
  componentId: "sc-6fjxuf-2"
})(["", " top:0.5rem;right:0.5rem;"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    bn br-100 bg-transparent f5 pa0 ma0 pointer absolute\n    ", "\n  "])), function (_ref2) {
  var modal = _ref2.theme.modal;
  return modal.closeButton;
}));

exports.StyledCloseButton = StyledCloseButton;